import React from 'react'
import SongListItem from './SongListItem';

export default function Sidebar({ currentSong,closeSidebar, playList,changeSong }) {
  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-header">
        <h2>Playlist</h2>
        <button onClick={() => closeSidebar()}>
          <i className="bi bi-x-lg header-icon"></i>
        </button>
      </div>
      <div className="song-list">
        {playList.map((item) => (
          <SongListItem
            key={item.id}
            song={item}
            changeSong={changeSong}
            currentSong={currentSong}
          />
        ))}
      </div>
    </div>
  );
}
